// import React, { useState, useEffect } from 'react';
// import { TabsNavbar, ReadyGroups, NewGroups, ClosedGroups, User, UserDetails } from '../components';
// import { API_BASE_URL } from '../utils/apiConfig'; // Import API_BASE_URL
// import { useUserContext } from '../context/user_context';
// import { useCompanySubscriberContext } from '../context/companysubscriber_context';
// import styled from 'styled-components';
// import { useHistory } from 'react-router-dom';
// import GroupDataInNavbar from '../components/GroupDataInNavbar';
// // //for ledger account
// import { useLedgerAccountContext } from "../context/ledgerAccount_context";
// import { useLedgerEntryContext } from "../context/ledgerEntry_context";
// import { useAobContext } from "../context/aob_context";

// import { useGroupsDetailsContext } from "../context/groups_context";


// const HomePage = () => {
//   const history = useHistory();
//   const [selectedTab, setSelectedTab] = useState('ready');
//   // const [groups, setGroups] = useState([]);

//   // const [premium, setPremium] = useState([]);
//   // const [profits, setProfits] = useState([]);

//   const { isLoggedIn, user } = useUserContext();
//   //const [membershipId, setMembershipId] = useState('');
//   // const { state, dispatch } = useCompanySubscriberContext();
//   // const { state, dispatch } = useGroupDetailsContext();

//   // Use distinct variable names for state and dispatch from different contexts
//   const { fetchCompanySubscribers } = useCompanySubscriberContext();
//   const { fetchLedgerAccounts } = useLedgerAccountContext();
//   const { fetchLedgerEntries } = useLedgerEntryContext();
//   const { fetchAobs } = useAobContext();
//   const { state, fetchAllGroups } = useGroupsDetailsContext();
//   const { groups, premium, profits, isLoading } = state;


//   // const fetchGroups = async () => {
//   //   try {
//   //     setIsLoading(true);
//   //     const apiUrl = `${API_BASE_URL}/users/groups`; // Construct the API URL using API_BASE_URL

//   //     const response = await fetch(apiUrl, {
//   //       method: 'GET',
//   //       headers: {
//   //         'Authorization': `Bearer ${user?.results?.token}`,
//   //         'Content-Type': 'application/json',
//   //       },
//   //     });

//   //     if (!response.ok) {
//   //       throw new Error('Failed to fetch groups');
//   //     }

//   //     const data = await response.json();
//   //     console.log('mani into home page');
//   //     console.log(data);



//   //     // if (data.results.groups && data.results.groups.length > 0) {
//   //     //   console.log('came into if condition');
//   //     //   console.log(data.results.groups);
//   //     //   setGroups(data.results.groups); // Set the data.results array into groups

//   //     // }
//   //     // if (data.results.earnedPremium && data.results.earnedPremium.length > 0) {
//   //     //   console.log('came into if condition');
//   //     //   console.log(data.results.earnedPremium);
//   //     //   setPremium(data.results.earnedPremium); // Set the data.results array into groups

//   //     // }
//   //     // if (data.results.subscribers && data.results.subscribers.length > 0) {
//   //     //   setSubscribers(data.results.subscribers); // Set the data.results array into groups
//   //     //   companySubscriberDispatch({ type: 'SET_SUBSCRIBERS', payload: data.results.subscribers });

//   //     // }





//   //   } catch (error) {
//   //     console.error(error);
//   //   } finally {
//   //     setIsLoading(false);
//   //   }
//   // };

//   useEffect(() => {
//     fetchAllGroups();
//     //fetchGroups();
//     fetchCompanySubscribers();
//     fetchLedgerAccounts();
//     fetchLedgerEntries();
//     fetchAobs();

//   }, [user]); // Include user as a dependency

//   // Log groups in a useEffect with a dependency on groups
//   useEffect(() => {
//     console.log('Manidiya');
//     console.log(groups);
//   }, [groups]);

//   // useEffect(() => {
//   //   if (user.results.userAccounts && user.results.userAccounts.length > 0) {

//   //     const membership = user.results.userAccounts[0];
//   //     console.log(membership.membershipId);
//   //     setMembershipId(membership.membershipId);
//   //   }
//   // }, [user]);

//   const handleStartGroup = () => {
//     history.push('/chit-fund/user/startagroup');

//   };

//   if (isLoading) {
//     return (
//       <>
//         <Loading />
//         <div className="placeholder" style={{ height: '50vh' }}></div>
//       </>
//     );
//   }

//   return (<section className='section'>
//     <Wrapper className='section-center'>

//       <div class="list-container">
//         <div >
//           {localStorage.getItem('unauthenticatedGroup') && <GroupDataInNavbar />}
//         </div>

//         <UserDetails groups={groups} premium={premium} />



//         < div class="grid-2" >
//           <h3>My Groups ({groups.length})</h3>
//           <div style={{ marginTop: "24px" }}>
//             {groups.length === 0 ? (
//               <>
//                 <button className="start-group-button" onClick={handleStartGroup}>
//                   Start a group
//                 </button>
//               </>
//             ) : (
//               <>
//                 <TabsNavbar
//                   selectedTab={selectedTab}
//                   onSelectTab={(tab) => setSelectedTab(tab)}
//                   groups={groups}
//                 />
//                 {selectedTab === 'ready' ? (
//                   <ReadyGroups groups={groups} selectedTab={selectedTab} />
//                 ) : selectedTab === 'new' ? (
//                   <NewGroups groups={groups} selectedTab={selectedTab} refreshGroups={fetchAllGroups} />
//                 ) : (
//                   <ClosedGroups groups={groups} /> // 👈 Add this for closed
//                 )}
//               </>
//             )}
//           </div>
//         </div >

//       </div >
//     </Wrapper >
//   </section >
//   );
// }
// // const Wrapper = styled.section`
// // min-height: 300vh;
// //  display: list;    
// // padding-top:20px;

// //    .list-container {
// //     display: list; 


// //   }

// //   .grid-1 {


// //     padding-top: 2rem;
// // display: grid;
// // gap: 3rem 2rem;
// // @media (min-width: 992px) {
// //   grid-template-columns: 1fr 1fr;
// // }

// //   }

// //   .fraction-1 {
// //    display:flex;

// //     text-align: center;
// //     flex-direction: column;

// //   }

// //   /* Add styling for the dashboard boxes */
// //   .dashboard-box {
// //     background-color: #ffffff;
// //     border-radius: 10px;
// //     padding: 15px;
// //     box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
// //     text-align: center;
// //     margin: 10px;
// //     width:10rem;
// //   }

// //   .dashboard-box h4 {
// //     font-size: 18px;
// //     color: #333;
// //   }

// //   .dashboard-box p {
// //     font-size: 24px;
// //     font-weight: bold;
// //     color: #007bff; /* Change the color to your preference */
// //   }

// //   /* Additional styles for .fraction-2 */
// //   .fraction-2 {

// //     display: grid;
// //     grid-template-columns: auto auto auto;
// //     align-items: center;
// //     justify-content: left;
// //     column-gap: 1rem;
// //     row-gap: 2px;
// //     margin-bottom: 3rem;


// //   }

// //   .mini-dashboard {
// //     display: flex;
// //     flex-direction: row;
// //     padding-left:8rem;

// //   }

// //   .grid-2,
// //   .grid-3 {
// //     background-color: #f0f0f0;
// //   padding: 20px; /* Adjust padding as needed */
// //   text-align: left;
// //   margin-top: 20px; /* Add margin at the top as needed */
// //   border-radius: 10px; /* Add border radius for rounded corners */

// // }
// //   }


// //   /* Additional styles for the button and victory cup image */
// // .start-group-button { 
// //   background-color: var(--clr-red-dark);
// //   color: #fff; /* Button text color */
// //   border: none;
// //   border-radius: 10px;
// //   padding: 10px 50px;
// //   width:200px;
// //   margin: 10px 60px; /* Adjust the margin as needed */
// //   cursor: pointer;
// //   display: flex;
// //   align-items: center;
// // }

// // .add-customer-button {
// //     background: transparent;
// //     border-color: transparent;
// //     width: 4rem;
// //     height: 4rem;
// //     background: var(--clr-red-dark);
// //     display: flex;
// //     align-items: center;
// //     justify-content: center;
// //     border-radius: 50%;
// //     color: var(--clr-white);
// //     cursor: pointer;
// //     margin-left: 2rem;
// //     margin-top: 1px;
// //     align-self: center;
// //     min-width: 2rem;

// // }

// // .start-group-button img {
// //   width: 20px; /* Adjust the width of the victory cup image */
// //   margin-left: 10px; /* Add spacing between text and image */
// // }
// //   @media (min-width: 992px) 
// //   {
// //     height: calc(100vh - 5rem);

// //   }

// //   .start-group-button {
// //     background-color: var(--clr-red-dark);
// //     color: #fff;
// //     border: none;
// //     border-radius: 10px;
// //     padding: 10px 50px;
// //     width: 200px;
// //     margin: 10px auto; /* Center horizontally */
// //     display: flex;
// //     align-items: center;
// //     justify-content: center; /* Center vertically */
// //     cursor: pointer;
// //   }
// // `
// const Wrapper = styled.section`
//   min-height: 100vh;
//   padding: 2rem 1rem;

//   .list-container {
//     max-width: 1200px;
//     margin: auto;
//   }

//   .grid-2 {
//     background-color: #ffffff;
//     padding: 2rem;
//     margin-top: 2rem;
//     border-radius: 12px;
//     box-shadow: 0 0 10px rgba(0,0,0,0.05);
//   }

//   h3 {
//     font-size: 1.5rem;
//     color: #333;
//     margin-bottom: 1.5rem;
//   }

//   .start-group-button {
//     background-color: var(--clr-red-dark);
//     color: #fff;
//     border: none;
//     border-radius: 8px;
//     padding: 12px 24px;
//     font-size: 1rem;
//     cursor: pointer;
//     transition: background 0.3s ease;
//     display: block;
//     margin: 2rem auto;
//   }

//   .start-group-button:hover {
//     background-color: #b30000;
//   }

//   @media (max-width: 768px) {
//     padding: 1rem;

//     .grid-2 {
//       padding: 1rem;
//     }
//   }
// `;


// export default HomePage;

import { useState, useEffect, useMemo } from 'react';
import { ReadyGroups, NewGroups, ClosedGroups, UserDetails, ScrollToTop } from '../components';
import { useHistory } from 'react-router-dom';
import GroupDataInNavbar from '../components/GroupDataInNavbar';
import { useUserContext } from '../context/user_context';
import { useCompanySubscriberContext } from '../context/companysubscriber_context';
import { useLedgerAccountContext } from "../context/ledgerAccount_context";
import { useLedgerEntryContext } from "../context/ledgerEntry_context";
import { useAobContext } from "../context/aob_context";
import { useGroupsDetailsContext } from "../context/groups_context";
import { FiPlus, FiSearch } from 'react-icons/fi';
import '../style/home.css';
import Loading from '../components/Loading';

const GROUPS_PAGE_SIZE_OPTIONS = [10, 20, 50];

const HomePage = ({
  basePath = '/chit-fund/user',
  canCreateGroup = true,
  groupsOnly = false,
  alwaysShowCreateGroup = false,
  canAddSubscriber = true,
  canDeleteGroup = true,
}) => {
  const history = useHistory();
  const [selectedTab, setSelectedTab] = useState('ready');
  const [query, setQuery] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const { user } = useUserContext();
  const { fetchCompanySubscribers } = useCompanySubscriberContext();
  const { fetchLedgerAccounts } = useLedgerAccountContext();
  const { fetchLedgerEntries } = useLedgerEntryContext();
  const { fetchAobs } = useAobContext();
  const { state, fetchAllGroups } = useGroupsDetailsContext();
  const { groups, premium, isLoading } = state;

  useEffect(() => {
    fetchAllGroups();
    fetchCompanySubscribers();
    fetchLedgerAccounts();
    fetchLedgerEntries();
    fetchAobs();
    // Only re-fetch when the auth session changes — not on every user object identity change.
  }, [user?.results?.token]);

  const handleStartGroup = () => {
    history.push(`${basePath}/startagroup`);
  };

  const filteredGroups = useMemo(() => {
    const list = Array.isArray(groups) ? groups : [];
    const q = query.trim().toLowerCase();
    if (!q) return list;
    return list.filter((group) => {
      const name = String(group.group_name || '').toLowerCase();
      const type = String(group.type || '').toLowerCase();
      return name.includes(q) || type.includes(q);
    });
  }, [groups, query]);

  const readyCount = filteredGroups.filter((g) => g.Status === 'Ready').length;
  const newCount = filteredGroups.filter((g) => g.Status === 'New').length;
  const closedCount = filteredGroups.filter((g) => g.Status === 'Closed').length;

  const tabStatus = selectedTab === 'new' ? 'New' : selectedTab === 'closed' ? 'Closed' : 'Ready';
  const tabGroups = filteredGroups.filter((g) => g.Status === tabStatus);
  const totalItems = tabGroups.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const currentPage = Math.min(page, totalPages);
  const startIndex = totalItems === 0 ? 0 : (currentPage - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, totalItems);
  const pagedGroups = tabGroups.slice(startIndex, endIndex);

  const getVisiblePageNumbers = (pages, current) => {
    if (pages <= 5) {
      return Array.from({ length: pages }, (_, index) => index + 1);
    }
    const windowSize = 5;
    let start = Math.max(1, current - Math.floor(windowSize / 2));
    let end = start + windowSize - 1;
    if (end > pages) {
      end = pages;
      start = Math.max(1, end - windowSize + 1);
    }
    return Array.from({ length: end - start + 1 }, (_, index) => start + index);
  };

  const pageNumbers = getVisiblePageNumbers(totalPages, currentPage);

  useEffect(() => {
    setPage(1);
  }, [selectedTab, query, pageSize]);

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-2 md:p-4">
        <div className="flex items-center justify-center min-h-[40vh] w-full">
          <div className="text-center">
            <Loading />
            {groupsOnly && <p className="text-gray-600 font-medium">Loading groups...</p>}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-2 md:p-4">
      <div className={groupsOnly ? 'max-w-7xl mx-auto' : 'list-container max-w-7xl mx-auto'}>
        {!groupsOnly && localStorage.getItem('unauthenticatedGroup') && <GroupDataInNavbar />}

        {!groupsOnly && <UserDetails groups={groups} premium={premium} />}

        {groupsOnly ? (
          <div className="group-container">
            <div className="groups-page-header">
              <div>
                <h1 className="text-2xl md:text-3xl font-extrabold text-gray-900">
                  Groups ({groups.length})
                </h1>
              </div>
              {canCreateGroup && (alwaysShowCreateGroup || groups.length === 0) && (
                <button
                  type="button"
                  className="inline-flex items-center justify-center gap-2 bg-red-600 hover:bg-red-700 text-white px-5 py-2.5 rounded-xl text-sm font-semibold shadow-sm"
                  onClick={handleStartGroup}
                >
                  <FiPlus className="w-4 h-4" />
                  Start a group
                </button>
              )}
            </div>

            {groups.length === 0 ? (
              <div className="group-empty mt-6">
                <p className="text-base font-semibold text-gray-800">No groups yet</p>
                <p className="text-sm text-gray-500 mt-1 mb-4">
                  Create a group to start collecting dues and running auctions.
                </p>
                {canCreateGroup && !alwaysShowCreateGroup && (
                  <button type="button" className="start-group-button" onClick={handleStartGroup}>
                    Start a group
                  </button>
                )}
              </div>
            ) : (
              <>
                <div className="groups-toolbar">
                  <div className="groups-search">
                    <FiSearch className="groups-search-icon" />
                    <input
                      type="search"
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                      placeholder="Search by name or type"
                      className="groups-search-input"
                    />
                  </div>
                  <div className="groups-tabs" role="tablist">
                    {[
                      { id: 'ready', label: 'Ready', count: readyCount },
                      { id: 'new', label: 'New', count: newCount },
                      { id: 'closed', label: 'Closed', count: closedCount },
                    ].map((tab) => (
                      <button
                        key={tab.id}
                        type="button"
                        role="tab"
                        aria-selected={selectedTab === tab.id}
                        className={`groups-tab ${selectedTab === tab.id ? 'is-active' : ''}`}
                        onClick={() => {
                          setSelectedTab(tab.id);
                          setPage(1);
                        }}
                      >
                        {tab.label}
                        <span className="groups-tab-count">{tab.count}</span>
                      </button>
                    ))}
                  </div>
                </div>

                {selectedTab === 'ready' && (
                  <ReadyGroups
                    groups={pagedGroups}
                    selectedTab={selectedTab}
                    refreshGroups={fetchAllGroups}
                    basePath={basePath}
                  />
                )}
                {selectedTab === 'new' && (
                  <NewGroups
                    groups={pagedGroups}
                    selectedTab={selectedTab}
                    refreshGroups={fetchAllGroups}
                    basePath={basePath}
                    canAddSubscriber={canAddSubscriber}
                    canDeleteGroup={canDeleteGroup}
                  />
                )}
                {selectedTab === 'closed' && <ClosedGroups groups={pagedGroups} basePath={basePath} />}

                {tabGroups.length > 0 && (
                  <div className="mt-4 bg-white rounded-xl shadow-lg border border-gray-200 p-3 sm:p-4 md:p-5">
                    <div className="flex flex-col gap-3 sm:gap-4 sm:flex-row sm:items-center sm:justify-between">
                      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 text-sm text-gray-600">
                        <span>
                          Showing <span className="font-semibold text-gray-900">{startIndex + 1}</span> to{' '}
                          <span className="font-semibold text-gray-900">{endIndex}</span> of{' '}
                          <span className="font-semibold text-gray-900">{totalItems}</span>
                        </span>
                        <div className="flex items-center gap-2">
                          <label htmlFor="groups-page-size" className="text-sm text-gray-600">Per page</label>
                          <select
                            id="groups-page-size"
                            value={pageSize}
                            onChange={(e) => setPageSize(Number(e.target.value))}
                            className="px-3 py-2 border border-gray-300 rounded-lg text-sm focus:ring-2 focus:ring-custom-red focus:border-transparent bg-white"
                          >
                            {GROUPS_PAGE_SIZE_OPTIONS.map((size) => (
                              <option key={size} value={size}>{size}</option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {totalPages > 1 && (
                        <div className="flex items-center justify-center sm:justify-end gap-1 flex-wrap">
                          <button
                            type="button"
                            onClick={() => setPage((p) => Math.max(1, p - 1))}
                            disabled={currentPage === 1}
                            aria-label="Previous page"
                            className={`min-w-[40px] h-10 px-3 rounded-lg text-lg font-semibold transition-colors ${
                              currentPage === 1
                                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                            }`}
                          >
                            &lt;
                          </button>

                          {pageNumbers[0] > 1 && (
                            <>
                              <button
                                type="button"
                                onClick={() => setPage(1)}
                                className="min-w-[40px] h-10 px-3 rounded-lg text-sm font-semibold bg-gray-100 text-gray-700 hover:bg-gray-200"
                              >
                                1
                              </button>
                              {pageNumbers[0] > 2 && (
                                <span className="px-1 text-gray-400 text-sm">…</span>
                              )}
                            </>
                          )}

                          {pageNumbers.map((pageNum) => (
                            <button
                              key={pageNum}
                              type="button"
                              onClick={() => setPage(pageNum)}
                              className={`min-w-[40px] h-10 px-3 rounded-lg text-sm font-semibold transition-colors ${
                                currentPage === pageNum
                                  ? 'bg-custom-red text-white'
                                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                              }`}
                            >
                              {pageNum}
                            </button>
                          ))}

                          {pageNumbers[pageNumbers.length - 1] < totalPages && (
                            <>
                              {pageNumbers[pageNumbers.length - 1] < totalPages - 1 && (
                                <span className="px-1 text-gray-400 text-sm">…</span>
                              )}
                              <button
                                type="button"
                                onClick={() => setPage(totalPages)}
                                className="min-w-[40px] h-10 px-3 rounded-lg text-sm font-semibold bg-gray-100 text-gray-700 hover:bg-gray-200"
                              >
                                {totalPages}
                              </button>
                            </>
                          )}

                          <button
                            type="button"
                            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                            disabled={currentPage === totalPages}
                            aria-label="Next page"
                            className={`min-w-[40px] h-10 px-3 rounded-lg text-lg font-semibold transition-colors ${
                              currentPage === totalPages
                                ? 'bg-gray-100 text-gray-400 cursor-not-allowed'
                                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                            }`}
                          >
                            &gt;
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        ) : null}
      </div>
      <ScrollToTop />
    </div>
  );
};

export default HomePage;
